import React from "react";
import { Link } from "react-router-dom";
import { Container } from "./CampaignsStyles";
import Tab from "../../components/common/Tab/Tab";

const Campaigns = () => {
  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>My Campaigns</h3>
          <p>View your team’s trades and transactions.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" to="/create-campaign">
            + Create Campaign
          </Link>
        </div>
      </div>

      <Tab campaign />
    </Container>
  );
};

export default Campaigns;
